// src/components/Intro.tsx
import React from "react";
import { Button } from "./Button";
import { LinkedIn } from "./LinkedIn";
import profileImg from "../assets/images/profile.jpg";

interface IntroProps {
  onNavigate: (section: "intro" | "portfolio" | "skills") => void;
}

export const Intro: React.FC<IntroProps> = ({ onNavigate }) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-r from-teal-500 to-teal-700 text-white p-6">
      <img
        src={profileImg}
        alt="Profile"
        className="w-40 h-40 rounded-full mb-4 shadow-lg"
      />

      <h1 className="text-3xl font-bold text-center mb-2">
        ¡Hola!
        <br />
        Soy Oscar Luna
      </h1>

      <p className="md:w-1/2 sm:w-4/5 text-md text-center mb-6">
        Desarrollador senior con más de 8 años de experiencia en el ámbito web y
        de aplicaciones, dispuesto a trabajar en equipo aportando soluciones a
        las distintas problemáticas que pudieran presentarse
      </p>

      <div className="flex space-x-4">
        <Button onClick={() => onNavigate("portfolio")}>Portafolio</Button>

        <Button onClick={() => onNavigate("skills")}>Habilidades</Button>
      </div>

      <a
        href="https://www.linkedin.com/in/oscar-alberto-d%C3%ADaz-luna"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-1/2 transform -translate-x-1/2"
      >
        <div className="inline-block transition-transform duration-300 ease-in-out hover:-translate-y-2">
          <LinkedIn />
        </div>
      </a>
    </div>
  );
};
